import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AppService } from '@shared/services/core/app.service';
import { LoadingService } from '@shared/services/core/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  lang = 'en';
  loading = false;

  showLoader = false;

  constructor(
    private translateService: TranslateService,
    private appService: AppService,
    public loadingService: LoadingService
  ) {
    this.lang = this.appService.getAppSettings().language;
    // const supportedLanguages = this.appService.getAppSettings().supportedLanguages;
    // this.translateService.addLangs(supportedLanguages);

    const browserLanguage = this.translateService.getBrowserLang() || this.lang;
    this.translateService.setDefaultLang(browserLanguage);

    this.translateService.use(this.lang);
  }

}
